import DefaultElementNodeType from '../DefaultElementNodeType';
import {BUSINESS_ROLE} from '../../metamodel/Concept';

export default class BusinessRoleNodeType extends DefaultElementNodeType {
	static get typeName() {
		return BUSINESS_ROLE;
	}
}
